import { DEFAULT_BYZZER_ERROR_MODAL_SUBTITLE, DEFAULT_BYZZER_ERROR_MODAL_TITLE } from "@/components/ByzzerModal/byzzerError.constants";
import {openErrorModal} from "@/components/form";
import React from "react";

export function showErrorModal(err) {
    return openErrorModal({
        title: DEFAULT_BYZZER_ERROR_MODAL_TITLE,
        content: (
            <>
                <p>{DEFAULT_BYZZER_ERROR_MODAL_SUBTITLE}</p>
            </>
        ),
        errorId: err.id
    });
}
